<template>
  <div class="new-box">
    <div class="type_box">
      <p>会员类型</p>
      <van-dropdown-menu>
        <van-dropdown-item v-model="mode" :options="option1" />
      </van-dropdown-menu>
    </div>
    <van-field class="input-item" :type="isShowPW?'password':''" label="登录密码"
      :right-icon="isShowPW?'closed-eye':'eye-o'" @click-right-icon="isShowPW = !isShowPW" v-model="password"
      placeholder="包含数字字符字母长度不小于8位"></van-field>
    <van-field class="input-item" :type="isShowPW2?'password':''" label="确认密码"
      :right-icon="isShowPW2?'closed-eye':'eye-o'" @click-right-icon="isShowPW2 = !isShowPW2" v-model="password2"
      placeholder="请再次输入您的登录密码"></van-field>
    <van-button class="nextBtn" type="primary" size="large" @click="check">下一步</van-button>
  </div>
</template>

<script>
  import { Field, Button, Toast, DropdownMenu, DropdownItem } from "vant";
  import { setNewPW } from "@/api/login";
  export default {
    props: {
      mobile: {
        type: String,
        default: ""
      }
    },
    data() {
      return {
        isShowPW: true,
        isShowPW2: true,
        mode: 1,
        password: "",
        password2: "",
        warmCode: 0,
        option1: [
          { text: '', value: 9 },
          { text: '个人会员', value: 1 },
          // { text: '团体会员', value: 2 }
        ],
      };
    },
    components: {
      [Field.name]: Field,
      [Button.name]: Button,
      [Toast.name]: Toast,
      [DropdownMenu.name]: DropdownMenu,
      [DropdownItem.name]: DropdownItem,
    },
    methods: {
      totalPass() {
        this.showPass = !this.showPass;
      },
      totalPassMore() {
        this.showPassMore = !this.showPassMore;
      },
      check() {
        let isChecked = this.$regexp.password(this.password),
          password = this.password,
          password2 = this.password2,
          regexpPassword = this.$regexp.chinese(password),
          params = {
            mobile: this.mobile,
            memberCategory: this.mode,
            password: this.password
          };

        if (!password) {
          Toast("请输入旧密码");
          return false;
        } else if (!password2) {
          Toast("请输入新密码");
          return false;
        }
        else if (!isChecked || regexpPassword) {
          Toast("密码必须包含数字、字符、字母长度不小于8位");
          return;
        } else if (password !== this.password2) {
          Toast("两次密码不一致");
          return;
        }

        setNewPW(params).then(res => {
          if (res.success) {
            this.$emit("success", this.password);
          } else {
            Toast.fail("设置失败，请确定会员类型！");
          }
        });
      }
    }
  };
</script>


<style lang="less" scoped>
  .input-item {
    padding: 0;
    padding-bottom: 12px;

    i {
      color: #aaa;
    }

    &+.input-item {
      margin-top: 20px;
    }
  }

  /deep/.van-field__label {
    width: 2.2rem;
  }

  .successedBtn {
    margin: 30px 0 25px 0 !important;
  }

  .rule-box {
    justify-content: center;
    margin-bottom: 20px;
  }

  .nextBtn {
    margin-top: 60px;
  }

  .type_box {
    overflow: hidden;
    border-bottom: 0.02667rem solid #ebedf0;
    margin-bottom: 30px;
    margin-top: -10px;
    position: relative;
  }

  .type_box p {
    font-size: 15px;
    height: 50px;
    line-height: 50px;
    color: #333;
    position: absolute;
    z-index: 99;
  }

  /deep/.van-field__label {
    width: 2.2rem
  }

  /deep/.van-dropdown-menu {
    width: 100%
  }

  /deep/.van-dropdown-menu__bar {
    box-shadow: initial;
  }

  /deep/.van-dropdown-menu__item {
    justify-content: flex-end
  }

  /deep/.van-dropdown-menu__title {
    margin-right: 6px;
  }
</style>